import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'brand-google-maps',
  'IconBrandGoogleMaps',
  [
    [
      'path',
      {
        d: 'M12 9.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0',
        key: 'svg-0',
      },
    ],
    ['path', { d: 'M6.428 12.494l7.314 -9.252', key: 'svg-1' }],
    ['path', { d: 'M10.002 7.935l-2.937 -2.545', key: 'svg-2' }],
    ['path', { d: 'M17.693 6.593l-8.336 9.979', key: 'svg-3' }],
    [
      'path',
      {
        d: 'M17.591 6.376c.472 .907 .715 1.914 .709 2.935a7.263 7.263 0 0 1 -.72 3.18a19.085 19.085 0 0 1 -2.089 3c-.784 .933 -1.49 1.93 -2.11 2.98c-.314 .62 -.568 1.27 -.757 1.938c-.121 .36 -.277 .591 -.622 .591c-.315 0 -.463 -.136 -.626 -.593a10.595 10.595 0 0 0 -.779 -1.978a18.18 18.18 0 0 0 -1.423 -2.091c-.877 -1.184 -2.179 -2.535 -2.853 -4.071a7.077 7.077 0 0 1 -.621 -2.967a6.226 6.226 0 0 1 1.476 -4.055a6.25 6.25 0 0 1 4.811 -2.245a6.462 6.462 0 0 1 1.918 .284a6.255 6.255 0 0 1 3.686 3.092z',
        key: 'svg-4',
      },
    ],
  ],
);
